import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ToggleService } from '../../shared/toggle-service/toggle.service';
import { ResourcesService } from '../../services/resources.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { UserService } from '../../services/user.service';
import { AccountService } from '../../services/account.service';
import { calculateDays, AlertType } from '../../helpers';

@Component({
  standalone: false,
  selector: 'app-header-new',
  templateUrl: './header-new.component.html',
  styleUrls: ['./header-new.component.css'],
})
export class HeaderNewComponent implements OnInit {
  carouselMessages = [];
  countNum = 0;
  interval: NodeJS.Timeout;
  alertType: 'warning' | 'danger' | 'custom' | 'expiredwithorg';
  showAlert = false;
  userData: any;
  constructor(
    private toggleService: ToggleService,
    private resourcesService: ResourcesService,
    private sanitizer: DomSanitizer,
    private readonly userService: UserService,
    private readonly accountService: AccountService,
    private cdr: ChangeDetectorRef,
  ) {
    this.getInfoMessages();
  }

  ngOnInit(): void {
    const user = this.userService.getUserDetails(false);
    if (user && user.userId) {
      this.getUserInfo(user.userId);
    }
  }

  getInfoMessages() {
    this.resourcesService.getResources(100000).subscribe((data) => {
      this.carouselMessages = data?.items
        ?.map((resource) => ({
          ...resource,
          description: this.sanitizeHTML(resource.description),
        }))
        .filter((r) => r.type.includes('INFO_MESSAGE'));
      this.carouselMessages.reverse();
      this.setCarouselInterval();
    });
  }

  changeInfoMessage(direction = true) {
    if (direction) {
      if (this.carouselMessages.length <= ++this.countNum) {
        this.countNum = 0;
      }
    } else {
      if (--this.countNum < 0) {
        this.countNum = this.carouselMessages.length - 1;
      }
    }
    clearInterval(this.interval);
    this.setCarouselInterval();
  }

  setCarouselInterval() {
    this.interval = setInterval(() => {
      if (this.carouselMessages.length > 0) {
        if (this.carouselMessages.length > this.countNum + 1) {
          this.countNum++;
        } else {
          this.countNum = 0;
        }
      } else {
        clearInterval(this.interval);
      }
    }, 10000);
  }

  sanitizeHTML(description: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }

  addClassToBodyForResponsiveMenu(): any {
    const body = document.querySelector('body');
    body.classList.toggle('menu-toggle');
    this.toggleService.toggleSidebarFixed();
  }

  getUserInfo(userId: string) {
    this.accountService.getUserDetails(userId).subscribe((data) => {
      this.userData = data;
      this.processBanner();
    });
  }

  processBanner() {
    const userClaim = this.userService.getUserClaim();
    const days = calculateDays(this.userData?.planExpiration);

    if (days <= 0 && userClaim['termhub:plan'] === 'GRACE_PERIOD') {
      this.alertType = AlertType['GRACEPERIOD'];
      this.showAlert = true;
    } else if (days <= 0 && userClaim['termhub:plan'] === 'EXPIRED') {
      this.alertType = AlertType['EXPIRED'];
      this.showAlert = true;
    } else if (days <= 0 && userClaim['termhub:plan'] === 'EXPIRED-WITH-ORG') {
      this.alertType = AlertType['EXPIREDWITHORG'];
      this.showAlert = true;
    } else if (days <= 30) {
      this.alertType = AlertType['WARNING'];
      this.showAlert = true;
    }

    this.cdr.detectChanges();
  }

  closeAlert() {
    this.showAlert = false;
  }
}
